import type { SVGProps } from 'react'

/** Line icons at a 24px box, 1.6 stroke. No emoji anywhere in the UI. */
function Icon({ children, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  )
}

export function GridIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="5.5" height="5.5" rx="1.4" />
      <rect x="9.25" y="3" width="5.5" height="5.5" rx="1.4" />
      <rect x="15.5" y="3" width="5.5" height="5.5" rx="1.4" />
      <rect x="3" y="9.25" width="5.5" height="5.5" rx="1.4" />
      <rect x="9.25" y="9.25" width="5.5" height="5.5" rx="1.4" fill="currentColor" />
      <rect x="15.5" y="9.25" width="5.5" height="5.5" rx="1.4" />
      <rect x="3" y="15.5" width="5.5" height="5.5" rx="1.4" />
      <rect x="9.25" y="15.5" width="5.5" height="5.5" rx="1.4" />
      <rect x="15.5" y="15.5" width="5.5" height="5.5" rx="1.4" />
    </Icon>
  )
}

export function TimelineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="8" y="3" width="9" height="6" rx="1.6" />
      <rect x="8" y="11" width="9" height="4" rx="1.6" />
      <rect x="8" y="17" width="9" height="4" rx="1.6" />
      <path d="M4 3.5v17" />
    </Icon>
  )
}

export function WeekIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M3 4.5h18" />
      <rect x="3" y="8" width="3.4" height="9" rx="1.2" />
      <rect x="10.3" y="8" width="3.4" height="12.5" rx="1.2" />
      <rect x="17.6" y="8" width="3.4" height="6.5" rx="1.2" />
    </Icon>
  )
}

export function InsightsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M3 19.5h18" />
      <path d="M5.5 16.5v-4" />
      <path d="M10 16.5V6.5" />
      <path d="M14.5 16.5v-7" />
      <path d="M19 16.5v-2.5" />
    </Icon>
  )
}

export function IterationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M4 8h11a4 4 0 0 1 0 8H9" />
      <path d="M7 5 4 8l3 3" />
      <path d="M12 13l-3 3 3 3" />
    </Icon>
  )
}

export function TrackerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="3" y="6" width="4" height="4" rx="1" />
      <rect x="10" y="6" width="4" height="4" rx="1" />
      <rect x="17" y="6" width="4" height="4" rx="1" />
      <rect x="3" y="14" width="4" height="4" rx="1" />
      <rect x="10" y="14" width="4" height="4" rx="1" />
    </Icon>
  )
}

export function SlidersIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M4 7.5h10" />
      <path d="M18 7.5h2" />
      <circle cx="16" cy="7.5" r="2.2" />
      <path d="M4 16.5h2" />
      <path d="M10 16.5h10" />
      <circle cx="8" cy="16.5" r="2.2" />
    </Icon>
  )
}

export function GoogleMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path
        fill="#4285F4"
        d="M23.5 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.45a5.5 5.5 0 0 1-2.39 3.6v3h3.86c2.26-2.08 3.58-5.15 3.58-8.79Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.08 7.94-2.91l-3.86-3c-1.08.72-2.45 1.15-4.08 1.15-3.13 0-5.78-2.11-6.73-4.96H1.29v3.1A12 12 0 0 0 12 24Z"
      />
      <path
        fill="#FBBC05"
        d="M5.27 14.28a7.2 7.2 0 0 1 0-4.56v-3.1H1.29a12 12 0 0 0 0 10.76l3.98-3.1Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.23 0 12 0A12 12 0 0 0 1.29 6.62l3.98 3.1C6.22 6.86 8.87 4.75 12 4.75Z"
      />
    </svg>
  )
}
